export default __webpack_public_path__ + "static/About-4e089828a23666a528705f02aad00167.jpg";